import { CoreEvent } from '@carvana/core-events';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CancelOrderModal } from '|/app/navigation-rail/components/modals';
import {
  VERIFX_OPEN_CANCEL_ORDER_MODAL,
  coreEventOffWithType,
  type VerifxModalEvents
} from '|/app/verifx-events';
import { isNativeWebview } from '|/helpers/is-native-app';
import { MobileWebviewEvents } from '|/helpers/mobile-webview-events';
import sendNativeEvent from '|/helpers/send-native-event';

const CancelOrderModalListener: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handler = () => {
      setIsOpen(true);
    };
    CoreEvent.onWithType<VerifxModalEvents, typeof VERIFX_OPEN_CANCEL_ORDER_MODAL>(
      VERIFX_OPEN_CANCEL_ORDER_MODAL,
      handler
    );
    return () => {
      coreEventOffWithType<VerifxModalEvents, typeof VERIFX_OPEN_CANCEL_ORDER_MODAL>(
        VERIFX_OPEN_CANCEL_ORDER_MODAL,
        handler
      );
    };
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    // This listener also mounts on CheckoutPage, where OPD never hid the chat UI to re-show.
    if (isNativeWebview() && pathname.includes('order-placed')) {
      sendNativeEvent({
        event: MobileWebviewEvents.TOGGLE_CHAT_UI,
        payload: { shouldShow: true },
        source: 'purchase'
      });
    }
  }, [pathname]);

  return <CancelOrderModal isOpen={isOpen} onClose={handleClose} />;
};

export default CancelOrderModalListener;
